import type { ParsedUrlQuery } from 'querystring'

import type { NonSymbolPrimitive } from '@/types'
import type { InternalQueryParam, QueryParam } from '@/constants'

export const toQS = (params: Record<string, NonSymbolPrimitive>) =>
  Object.keys(params)
    .filter((key) => params[key])
    .map((key) => `${key}=${params[key]}`)
    .join('&')

// the queryParams this is used for should never have a parsed value that is an array
export const getQueryParamValueAsString = (paramName: QueryParam | InternalQueryParam, query: ParsedUrlQuery) => {
  const queryVal = query[paramName]
  return Array.isArray(queryVal) ? queryVal[0] : queryVal
}

export default {}
